<template>
  <ag-grid-vue
    ref="dataGridContacts"
    theme="legacy"
    :rowData="activityLogContacts"
    :columnDefs="colDefs"
    :defaultColDef="defaultColDefs"
    :autoSizeStrategy="{ type: 'fitGridWidth' }"
    suppressCellFocus
    class="basis-1/2"
    :class="darkVal ? 'ag-theme-quartz-dark' : 'ag-theme-quartz'"
    @grid-size-changed="resize"
  ></ag-grid-vue>
  <TSDialog v-model:visible="contactingEntity" :label="'Send Email to Project Entity'" size="" icon="chart-line">
    <template #content>
      <ActivityContactForm
        v-if="contactingEntity"
        :project="project"
        :contact="contactingEntity"
        :reached-allocated-inspections="reachedAllocatedInspections"
      ></ActivityContactForm>
    </template>
  </TSDialog>
</template>

<script setup lang="ts">
import { AgGridVue } from "ag-grid-vue3";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-quartz.css";
import { usePropsStore } from "@/stores/props";
import type { ActivityLogContact } from "@/types/ActivityLog";
import { computed, ref } from "vue";
import ButtonIconCellRenderer from "@/components/cell-renderers/ButtonIconCellRenderer.vue";
import TSDialog from "@/components/global/TSDialog.vue";
import ActivityContactForm from "./ActivityContactForm.vue";
import type { Project } from "@/types/Projects";

const dataGridContacts = ref();
const activityLogContacts = defineModel<ActivityLogContact[]>("activityLogContacts", { required: true });
const project = defineModel<Project>("project", { required: true });
const reachedAllocatedInspections = defineModel<boolean>("reachedAllocatedInspections", { required: true });
const propsStore = usePropsStore();
const darkVal = computed<boolean>(() => propsStore.darkMode);

const contactingEntity = ref<ActivityLogContact>();

const resize = (): void => {
  dataGridContacts.value.api.sizeColumnsToFit();
};

const send = (data: ActivityLogContact): void => {
  contactingEntity.value = data;
};

const defaultColDefs = {
  filter: true,
  floatingFilter: false,
  cellDataType: "text",
  editable: false,
  resizable: false,
  filterable: false,
};

const colDefs = ref([
  {
    field: "name",
    headerName: "Name",
    cellDataType: "text",
  },
  {
    field: "entityType",
    headerName: "Type",
    cellDataType: "text",
  },
  {
    headerName: "",
    filter: false,
    width: 0,
    cellRenderer: ButtonIconCellRenderer,
    cellRendererParams: {
      icon: "pi-send",
      callback: send,
      offset: "",
    },
  },
]);
</script>
